<template>
    <b-card shadow type="secondary" title="Category">
        <b-card-body>
            <b-form @submit.stop.prevent="onSubmit">
                <b-form-group
                    id="name-group"
                    label="Name"
                    label-for="input-name"
                >
                    <!-- disable editability if the user can view but not update -->
                    <b-form-input
                        type="text"
                        id="input-name"
                        v-model="model.name"
                        required
                        placeholder="Enter Name"
                        trim
                        :disabled="canView"
                    ></b-form-input>
                </b-form-group>

                <b-button
                    variant="secondary"
                    :disabled="loading ? true : false"
                    @click="cancel()"
                    >{{ cancelLabel }}</b-button
                >
                <!-- render the submit button only if the user can update or create -->
                <b-button
                    type="submit"
                    variant="primary"
                    :disabled="loading ? true : false"
                    v-if="canUpdate || canCreate"
                    >{{ submitLabel }}</b-button
                >
                <b-button
                    @click="deleteItem()"
                    class="mr-2"
                    variant="warning"
                    v-if="
                        this.model.id &&
                            user_permissions.includes('delete.order.categories')
                    "
                >
                    Delete Item
                </b-button>
            </b-form>
        </b-card-body>
    </b-card>
</template>
<script>
export default {
    name: 'ViewItem',
    data() {
        return {
            model: {
                id: 0,
                name: null,
            },
            loading: false,
            hasErrors: false,
        }
    },
    props: ['item'],
    computed: {
        /**
         * True if the user has permissions to create and clicked the create button, otherwise false.
         */
        canCreate() {
            console.log(this.user_permissions)
            return !this.model.id &&
                this.user_permissions.includes('create.order.categories')
                ? true
                : false
        },
        /**
         * True if the user has permission to view but not update an order category and clicked the view button on a category in the table, otherwise false.
         */
        canView() {
            return this.model.id &&
                !this.user_permissions.includes('update.order.categories') &&
                this.user_permissions.includes('view.order.categories')
                ? true
                : false
        },
        /**
         * True if the user has permission to update an order category and clicked the view button on a category in the table, otherwise false.
         */
        canUpdate() {
            return this.model.id &&
                this.user_permissions.includes('update.order.categories')
                ? true
                : false
        },
        submitLabel() {
            if (this.loading && this.model.id) {
                return 'Updating...'
            } else if (this.loading) {
                return 'Creating...'
            } else if (this.model.id) {
                return 'Update'
            } else {
                return 'Create'
            }
        },
        cancelLabel() {
            if (this.canView) {
                return 'Back'
            } else {
                return 'Cancel'
            }
        },
        user_permissions() {
            return this.$store.getters.user_permissions
        },
    },
    watch: {},
    mounted() {
        if (this.item.id) this.model = this.item
    },
    methods: {
        cancel() {
            this.$emit('cancel')
        },
        onSubmit() {
            this.loading = true
            const model = { ...this.model }
            console.log('model', model)
            const path = `orderCategory/${model.id ? 'update' : 'create'}`
            this.$validator.validate().then(valid => {
                if (valid) {
                    this.loading = true
                    this.$store
                        .dispatch(path, model)
                        .then(() => {
                            this.loading = false
                            this.$emit('success', !!model.id)
                        })
                        .catch(error => {
                            console.log('error', error)
                        })
                        .finally(() => {
                            this.loading = false
                        })
                } else {
                    this.loading = false
                }
            })
        },
        deleteItem() {
            // Initializing key variables
            console.log('Attempt to delete')
            const model = { ...this.model }
            const path = 'orderCategory/delete'

            // Generate and display confirmation prompt
            const title = 'Delete Order Category?'
            const message = `Are you sure you want to delete ${model.name}?`
            const errorMsg = 'Unable to delete Order Category!'

            this.$emit(
                'delete-item',
                message,
                title,
                model.id,
                () => {
                    this.$emit('success', 'Deleted')
                },
                path,
                errorMsg
            )
        },
    },
}
</script>
<style></style>
